export const baseurl = "https://cineplex-web-api.cineplexbd.com";
